module.exports = __webpack_public_path__ + "static/media/AlertIcon.6b4e9b12.svg";